import { z } from 'zod';
/**
 * Phase 3 (doc 11 §3) — the one event envelope every producer writes and
 * every consumer narrows. Versioning rule is ADDITIVE: payload schemas use
 * passthrough so consumers tolerate fields added by newer producers; a
 * breaking change requires a new `version` and a new catalog entry.
 *
 * `id` doubles as the OutboxEvent primary key and the consumer dedup key
 * (at-least-once delivery → consumers must treat a repeated id as a no-op).
 * `correlationId` carries the originating request id (request-context ALS);
 * `causationId` points at the event that caused this one, when chained.
 */
export const eventEnvelope = z.object({
    id: z.string().uuid(),
    type: z.string().min(1),
    version: z.number().int().positive(),
    vendorId: z.number().int().positive(),
    /** ISO-8601 — Date objects don't survive JSON transport. */
    occurredAt: z.string(),
    correlationId: z.string().nullish(),
    causationId: z.string().nullish(),
    payload: z.unknown(),
});
